import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
	"/_authenticated/(web-app)/_web/web/$orgId/tickets/(ticket)/$ticketId/workspace/assets/$assetId/_drawer/details",
)({
	/** Tab body is composed by the drawer layout into Figma `Details`. */
	component: () => null,
});
